import React from 'react'

const CardListIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="42" height="42" viewBox="0 0 60 60" fill="none" {...props}>
    <circle cx="30" cy="30" r="30" fill="#78BE20" />
    <g
      clipPath="url(#clip0)"
      stroke="#fff"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round">
      <path d="M39.625 21.906H19.375a.844.844 0 0 0-.844.844V36.25c0 .466.378.844.844.844h20.25c.466 0 .844-.378.844-.844V22.75a.844.844 0 0 0-.844-.844Z" />
      <path d="M33.719 33.719h3.375M28.656 33.719h1.688M18.531 26.125h21.938" />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="27" height="27" x="16" y="16" />
      </clipPath>
    </defs>
  </svg>
)

export default CardListIcon
